import { render } from "./AllProjects.vue?vue&type=template&id=0c963309&ts=true"
import script from "./AllProjects.vue?vue&type=script&lang=ts"
export * from "./AllProjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__